import type {BackgroundFilterMode} from "../../helper/BackgroundFilter";

// RISKS.md/P2.28: persisted background preference. Validated on read, so a value from an older
// build can't hand BackgroundFilter.apply() a mode this version no longer supports.
export const BACKGROUND_STORAGE_KEY = 'backgroundFilter'
const BACKGROUND_MODES: BackgroundFilterMode[] = ['none', 'blur', 'hide']

export const readStoredBackground = (): BackgroundFilterMode => {
  const stored = localStorage.getItem(BACKGROUND_STORAGE_KEY) as BackgroundFilterMode | null
  return stored && BACKGROUND_MODES.includes(stored) ? stored : 'none'
}

// Remembered per browser, and safe only because a stored id that no longer resolves fails
// loudly rather than being silently swapped for another device (RISKS.md/P2.52).
export const readStoredDevice = (key: string): string | null => localStorage.getItem(key) || null

// The user's last deliberate pick, consulted whenever the selection has drifted off it — a block
// hid the ids, or the device simply came back (RISKS.md/P2.53).
export const rememberedDevice = (devices: MediaDeviceInfo[], key: string) => {
  const id = readStoredDevice(key)
  return id ? devices.find(d => d.deviceId === id) : undefined
}

// Only ever writes. A block briefly sets a blank id, and clearing on that erased the remembered
// choice (RISKS.md/P2.53).
export const persistDevice = (key: string, id: string | null) => {
  if (id) localStorage.setItem(key, id)
}
